module.exports = __webpack_public_path__ + "static/media/member-login.402d1b29.svg";